// Utility functions for data key creation and extraction.
// These must match backend infrastructure (e.g., S3 key paths) exactly.
// Centralizing this logic avoids bugs from duplicated or inconsistent key handling.

export function extractMajorVersion(version: string | null): string {
  // Extracts the major version (e.g., '1' from '1.2.3'). Throws if invalid.
  if (!version) throw new Error("Version is required");
  const major = version.split(".")[0];
  if (!major) throw new Error(`Invalid version format: ${version}`);
  return major;
}

export function createDataKey({
  solutionKey,
  useCaseKey,
  version,
  dataId
}: {
  solutionKey: string;
  useCaseKey: string;
  version: string | null;
  dataId?: string;
}): string {
  if (!solutionKey || !useCaseKey || !dataId) {
    throw new Error("Missing required parameters for data key");
  }
  const majorVersion = extractMajorVersion(version);
  // This correlates to S3 key path where the data is stored, must exactly match the backend infrastructure
  return `${solutionKey}/${useCaseKey}/${majorVersion}/${dataId}`;
}

export function extractDataId(dataKey?: string): string {
  // Extracts the dataId from a dataKey (last segment after last slash)
  if (!dataKey) throw new Error("Data key is required");
  const dataId = dataKey.split("/").slice(-1)[0];
  if (!dataId) throw new Error(`Invalid data key format: ${dataKey}`);
  return dataId;
}
